// src/components/ServiceWorkerRegistrar.tsx
'use client';

import { useEffect } from 'react';

export function ServiceWorkerRegistrar() {
  useEffect(() => {
    if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) {
      return;
    }
    navigator.serviceWorker.register('/sw.js', { scope: '/' }).catch(() => {
      // Registration failures are non-fatal: the dashboard works without it.
    });
  }, []);

  return null;
}
